export default __webpack_public_path__ + "static/img_2_0-2ada74b95f00dd0928023e429f8554fa.jpg";